var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionsLightGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        Icon / Options\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n        Created with Sketch.\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Options"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Options"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#a3adb9",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(31.500000, 33.250000) scale(1, -1) rotate(90.000000) translate(-31.500000, -33.250000) translate(29.500000, 29.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M0,4 L4,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M0,4 L4,0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    width: 64,
    height: 64,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 31.5,
    cy: 32.5,
    r: 10.5,
    stroke: "#a3adb9",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsLightGrey);
export default __webpack_public_path__ + "static/media/OptionsLightGrey.bccc5ee62356bc62eff2124809621a35.svg";
export { ForwardRef as ReactComponent };